import { render, staticRenderFns } from "./PersonalID.vue?vue&type=template&id=34d5b050"
import script from "./PersonalID.vue?vue&type=script&lang=js"
export * from "./PersonalID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports